import api from '../../utils/api';

const state = {
	chargeBreakdown: {},
	merchantName: '',
	testStatus: false,
	isPaga: null,
	merchantEnvironment: {}
};

const getters = {
	getChargeBreakdown: (state) => state.chargeBreakdown,
	getMerchantName: (state) => state.merchantName,
	getTestStatus: (state) => state.testStatus,
	getIsPaga: (state) => state.isPaga,
	getMerchantEnvironment: (state) => state.merchantEnvironment
};

const mutations = {
	setChargeBreakdown: (state, data) => {
		state.chargeBreakdown = data;
	},
	setMerchantName: (state, data) => {
		state.merchantName = data;
	},
	setTestStatus: (state, data) => {
		state.testStatus = data;
	},
	setIsPaga: (state, data) => {
		state.isPaga = data;
	},
	setMerchantEnvironment: (state, data) => {
		state.merchantEnvironment = data;
	}
};

const actions = {
	catchTypeError({ commit }, error) {
		let errorData = {};
		try {
			const errorData = JSON.parse(error);
			commit('reqError', null, { root: true });
			commit('setErrorMessage', errorData.message);
			commit('clearErrorStatus', null, { root: true });
			commit('setIsLoading', false);
			commit('setIframeResponseOnError', {
				message: errorData.message,
				type: 'ERROR'
			});
		} catch (error) {
			errorData.message = 'Your request could not be completed at the moment. Please check your network connection and try again later.';
			commit('reqError', null, { root: true });
			commit('setErrorMessage', errorData.message);
			commit('setIsLoading', false);
			commit('setIframeResponseOnError', {
				message: errorData.message,
				type: 'ERROR'
			});
			commit('clearErrorStatus', null, { root: true });
		}
	},

	fetchChargeBreakdown({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('transactions/initiate', data)
			.then((response) => {
				if (response.status !== 200) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then((response) => {
				commit('updateToken', response.token);
				commit('setChargeBreakdown', response);
				commit('setMerchantName', response.merchant);
				commit('setIsLoading', false);
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async fetchLoanPartners({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api.get(`loans/partners?amount=${data.amount}`, data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setMerchantEnvironment', response);
				commit('setIsLoading', false);
				commit('setPartners', response.data);
				commit('setTestStatus', true);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},
	async postFeedback({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api.post('loans/feedback', data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setMerchantEnvironment', response);
				commit('setIsLoading', false);
				commit('setPartners', response.data);
				commit('setTestStatus', true);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions,
	state,
	mutations,
	getters
};
